<template>
    <div>
        <div class="complaints">
            <h2>Жалобы</h2>
            <div v-for="(item, key) in getDiagnostic.complaints" :key="`complaint_${key}`" class="item-wrap" v-show="getDiagnostic.complaints.length > 0 && !loadAll">
                <v-textarea
                    class="mt-8"
                    rows="1"
                    auto-grow
                    no-resize
                    :ref="`ref-complaintText-${key+1}`"
                    :disabled="!item.isVisible"
                    :readonly="getFlagReadonly"
                    @input="saveThroughTime({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateComplaint',
                        index: key,
                        nameGroup: 'diagnostic',
                        nameProperty: 'complaints'
                    }, true); item.inputText = true;"
                    @blur="switchSave({
                        obj: item,
                        url: 'DiaTest/AddOrUpdateComplaint',
                        index: key,
                        nameGroup: 'diagnostic',
                        nameProperty: 'complaints'
                    }, true)"
                    v-model="item.complaintText"
                    :rules="[rules.maxSymbol]"
                    outlined
                    placeholder="Введите текст..."
                />
                <div class="switch">
                    <p>Патология</p>
                    <div class="switch-item">
                        <span>Нет</span>
                        <v-switch
                            :disabled="getFlagReadonly || !item.isVisible"
                            v-model="item.isPathology"
                            @change="switchSave({
                                obj: item,
                                url: 'DiaTest/AddOrUpdateComplaint',
                                index: key,
                                nameGroup: 'diagnostic',
                                nameProperty: 'complaints'
                            }, false)"
                        />
                        <span>Да</span>
                    </div>
                </div>
                <div class="switch">
                    <div class="switch__block-btn">
                        <v-btn title="Удалить" v-if="item.testDataType === 3 && !getFlagReadonly" @click.prevent="deleteComplaints(item)" class="mt-7" color="error" large>
                            <v-icon color="white">mdi-delete</v-icon>
                        </v-btn>
                        <v-btn :loading="item.loadReturn" v-if="item.testDataType === 2" title="Вернуть к исходному состоянию" @click.prevent="returnInitianState(item, key)" class="mt-7" color="info" large>
                            <v-icon color="white">mdi-restore</v-icon>
                        </v-btn>
                        <v-btn :loading="item.loadViewOrNot" title="Скрыть" v-if="item.testDataType === 1 && !getFlagReadonly" @click.prevent="viewOrNot(item, key)" class="mt-7" color="info" large>
                            <v-icon color="white">
                                {{ item.isVisible ? 'mdi-eye-off' : 'mdi-eye' }}
                            </v-icon>
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-skeleton-loader
                v-for="item in 3"
                :key="item"
                v-show="loadAll && getDiagnostic.complaints.length === 0"
                type="list-item-three-line"
            />

            <button
                v-if="!getFlagReadonly && !loadAll"
                type="button"
                @click.prevent="addComplaints"
                :disabled="addDisabled()"
                class="custom-button"
                :class="{ 'btn-disabled': addDisabled() }">
                + Добавить
            </button>
        </div>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import debounce from 'lodash.debounce';

export default {
    name: 'Complaints',
    components: {
        TimeoutSnackbar
    },
    computed: {
        ...mapGetters({
            getDiagnostic: 'createDiagnosticTest/getDiagnostic',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        }),
    },
    data: () => ({
        loadAll: true,
        snackbar: {
            show: false,
            text: null,
            color: null,
            timeout: -1
        },
        rules: {
            maxSymbol: (v) => v.length <= 220 || 'Максимум 220 символов.'
        }
    }),
    methods: {
        ...mapMutations({
            addComplaints: 'createDiagnosticTest/addComplaints',
            changeFlagMissingStep: 'createDiagnosticTest/changeFlagMissingStep',
            saveComplaints: 'createDiagnosticTest/saveComplaints'
        }),
        ...mapActions({
            getComplaints: 'createDiagnosticTest/getComplaints',
            saveInline: 'createDiagnosticTest/saveInline',
            getVisibleBlockInDiagnostic: 'createDiagnosticTest/getVisibleBlockInDiagnostic',
            deleteComplaint: 'createDiagnosticTest/deleteComplaint',
            resetValue: 'createDiagnosticTest/resetValue'
        }),
        addDisabled() {
            if (this.getDiagnostic.complaints.length === 0) {
                return false;
            }

            let index = this.getDiagnostic.complaints.length - 1;
            let last = this.getDiagnostic.complaints[index];
            return !last.complaintText;
        },
        switchSave(obj, checkSave) {
            let input = this.$refs[`ref-complaintText-${obj.index+1}`];

            if(input && input[0] && input[0].validate()) {
                // Если testDataType = 1 (EpisodeOnly), то при редактировании меняем тип на 2 и показываем кнопку вернуть к исходному состоянию
                if(obj.obj.testDataType === 1) obj.obj.testDataType = 2;
                
                // Если мы сохраняем текстовое поле, то проверим на повторное сохранение
                if(checkSave) {
                    if(!obj.obj.inputText) return;
                }

                this.saveInline(obj)
                .then(() => {
                    this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };
                    obj.obj.inputText = false;
                })
                .catch((error) => {
                    if(error) {
                        // console.log(error);
                        this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                        obj.obj.inputText = false;
                    }
                })
            } else {
                this.snackbar = { text: 'Проверьте корректность введенных данных!', color: 'error', timeout: 3000, show: true };
            }
        },
        saveThroughTime: debounce( function (obj, checkSave) {
            let input = this.$refs[`ref-complaintText-${obj.index+1}`];

            if(input && input[0] && input[0].validate()) {
                this.switchSave(obj, checkSave)
            } else {
                this.snackbar = { text: 'Проверьте корректность введенных данных!', color: 'error', timeout: 3000, show: true };
            }
        }, 2000),
        deleteComplaints(item) {
            if(confirm(`Вы уверены, что хотите удалить жалобу ?`)) {
                this.deleteComplaint({ item, testId: this.$route.params.id});
            }
        },
        viewOrNot(item, key) {
            item.loadViewOrNot = true;

            this.saveInline({ obj: { ...item, isVisible: !item.isVisible, testDataType: item.testDataType === 1 ? 2 : item.testDataType }, url: 'DiaTest/AddOrUpdateComplaint', index: key, nameGroup: 'diagnostic', nameProperty: 'complaints' })
                .then(() => {
                    item.loadViewOrNot = false;
                })
        },
        returnInitianState(item, key) {
            item.loadReturn = true;

            this.resetValue({ item, levelDeep: 1, url: 'ResetComplaintValue', index: key, nameGroup: 'diagnostic', nameProperty: 'complaints', testId: this.$route.params.id })
                .then(() => {
                    item.loadReturn = false;
                })
        }
    },
    destroyed() {
        this.saveComplaints([]);
    },
    created() {
        // Если предыдущая нумерация пропущена и у этой нумерации состояние 1/3 то вызываем окно с подтверждением
        if(this.getDiagnostic.levels[0].visibleType !== 2) {
            this.changeFlagMissingStep({ flag: true, index: 0 });
        }

        this.getComplaints(this.$route.params.id)
            .then((res) => {
                if(res.length === 0) this.addComplaints();
                this.loadAll = false;
            })
    }
}
</script>
